import {Time} from 'yougile-util'
import {DataObjectId, DeadlineStickerValue, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {updateStickerDates} from '@components/add-task/get-required-stickers'
import {Sticker} from '@extensions/sticker/sticker'

export const updateShiftDeadline = (hub?: Hub): void => {
  if (!hub) {
    return
  }

  updateDeadlineForHub(hub)

  const subtaskIds = Object.keys(hub.data.subtaskList?.subtasks || {})

  const box = Sync.getCurrentSandbox()
  for (const subtaskId of subtaskIds) {
    const subtask = box.getHub(subtaskId)
    if (!subtask) {
      continue
    }
    updateDeadlineForHub(subtask)
  }
}

const updateDeadlineForHub = (hub?: Hub): void => {
  if (!hub) {
    return
  }

  const stickers = hub.stickers
  const box = Sync.getCurrentSandbox()

  for (const stickerId of Object.keys(stickers) as DataObjectId[]) {
    const tag = Sticker.getById(box, stickerId)
    if (tag.title === 'Deadline') {
      const value = stickers[stickerId]
      const deadlineValue = (value as DeadlineStickerValue).current
      if (value) {
        const now = Time.now()

        const deadlineStart = Time.startOfDay(deadlineValue.timestamp)
        const nowStart = Time.startOfDay(now)

        const shift =
          Time.day * Math.floor((nowStart - deadlineStart) / Time.day)

        updateStickerDates(value, shift)
      }
    }
  }
}
